module.exports = __webpack_public_path__ + "img/BA-macbook@2x.41c3d574.png";